import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import {IS_AUTHENTICATED} from '../store/modules/auth';
import {GET_INSTALLATION_PLACED} from '../store/modules/proposal_progress';
import {SET_LANGUAGE} from '../store/modules/locale';
import Orders from '@/pages/Orders';
import Support from '@/pages/Support';
import Account from '@/pages/Account';
import ViewAccount from '../components/account/ViewAccount';
import AccountInfoForm from '../components/account/AccountInfoForm';
import ChangePassword from '../components/account/ChangePassword';
import Referrals from '../pages/Referrals';
import Experiences from '../pages/Experiences';
import Styleguide from '@/pages/Styleguide';
import PageNotFound from '@/pages/PageNotFound';
import AuthenticationPage from '@/pages/AuthenticationPage';
import Guidelines from '@/pages/Guidelines';
import WelcomePage from '../pages/WelcomePage';
import OrderSaltBlocks from '../pages/OrderSaltBlocks';

// Authentication Pages
import LoginForm from '@/components/auth/forms/LoginForm';
import RegisterForm from '@/components/auth/forms/RegisterForm';
import PasswordResetForm from '@/components/auth/forms/PasswordResetForm';
import PasswordForgottenForm from '@/components/auth/forms/PasswordForgottenForm';
import ActivationForm from '@/components/auth/forms/ActivationForm';
import Raven from 'raven-js';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/account',
        },
        {
            path: '/saltblocks',
            name: 'saltblocks',
            component: OrderSaltBlocks,
            meta: {
                auth: true,
                crumbs: ['home'],
            },
        },
        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            meta: {
                auth: true,
                crumbs: ['home'],
            }
        },
        {
            path: '/support',
            name: 'support',
            component: Support,
            meta: {
                auth: true,
                crumbs: ['home'],
            }
        },
        {
            path: '/account',
            component: Account,
            meta: {
                auth: true,
            },
            children: [
                {
                    path: '/',
                    name: 'account',
                    component: ViewAccount,
                    meta: {
                        crumbs: ['home'],
                    },
                },
                {
                    path: 'edit',
                    name: 'edit-account',
                    component: AccountInfoForm,
                    meta: {
                        crumbs: ['home', 'account'],
                    },
                },
                {
                    path: 'password',
                    name: 'change-password',
                    component: ChangePassword,
                    meta: {
                        crumbs: ['home', 'account'],
                    },
                },
                {
                    path: 'password',
                    name: 'password-reset-form',
                    component: ChangePassword,
                    meta: {
                        crumbs: ['home', 'account'],
                    },
                },
            ],
        },
        {
            path: '/experiences',
            name: 'experiences',
            component: Experiences,
            meta:{
                crumbs: ['home']
            }
        },
        {
            path: '/referrals',
            name: 'referrals',
            component: Referrals,
            meta: {
                auth: true,
                crumbs: ['home'],
            }
        },
        {
            path: '/welcome-to-minimax',
            name: 'welcome',
            component: WelcomePage,
            meta: {
                auth: true,
                crumbs: ['home'],
            },
        },
        {
            path: '/styleguide',
            name: 'styleguide',
            component: Styleguide,
            meta: {
                auth: false,
                crumbs: ['home'],
                debugRoute: true,
            }
        },
        {
            path: '/guidelines',
            name: 'guidelines',
            component: Guidelines,
            meta: {
                auth: false,
                crumbs: ['home'],
                debugRoute: true,
            }
        },
        {
            path: '/auth',
            component: AuthenticationPage,
            children: [
                {
                    path: '/',
                    name: 'sign-in',
                    component: LoginForm,
                    meta: {
                        crumbs: ['home'],
                    },
                },
                {
                    path: 'register',
                    name: 'register',
                    component: RegisterForm,
                    meta: {
                        crumbs: ['home', 'sign-in'],
                    },
                },
                {
                    path: 'reset',
                    name: 'reset',
                    component: PasswordForgottenForm,
                    meta: {
                        crumbs: ['home', 'sign-in'],
                    },
                },
                {
                    path: 'reset/:token',
                    name: 'reset/token',
                    component: PasswordResetForm,
                    meta: {
                        crumbs: ['home'],
                    },
                },
                {
                    path: 'activate/:token',
                    name: 'activate',
                    component: ActivationForm,
                    meta: {
                        crumbs: ['home'],
                    },
                }
            ]
        },
        {
            path: '**',
            name: 'page-not-found',
            component: PageNotFound,
            meta: {
                crumbs: ['home'],
            },
        }
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        // Check if user is signed in. Route requires sign in.
        if (!store.getters[IS_AUTHENTICATED]) {
            next({
                name: 'sign-in',
                query: {
                    redirect: to.path
                }
            });
            return;
        } else {
            //re-route to proposal if installation is not placed
            if (!store.getters[GET_INSTALLATION_PLACED]) {
                if (to.name !== 'welcome'){
                    next({
                        name: 'welcome',
                    });
                    return;
                }
            } else {
                // If installation is placed, redirect from welcome to saltblocks
                if (to.name === 'welcome') {
                    next({
                        name: 'saltblocks',
                    });
                    return;
                }
            }
        }
    }
    next();
});

router.beforeEach((to, from, next) => {
    try {
        if (to.query.force_lang === 'nl'){
            store.dispatch(SET_LANGUAGE, 'nl');
        }
        if (to.query.force_lang === 'fr'){
            store.dispatch(SET_LANGUAGE, 'fr');
        }
    } catch (e){
        Raven.captureException(e);
    }
    next();
});

/**
* Disable debug routes (stylesheet, etc) on production
*/
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.debugRoute)) {
        if (!Vue.prototype.$config.debug) {
            next({ path: '/page-not-found' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js